// Live listener for a single event doc. Applies branding to :root as a
// side-effect so every surface gets themed immediately on first load.

import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { applyBranding } from "./theme";
import type { EventDoc } from "../types";

export interface EventState {
  event: EventDoc | null;
  loaded: boolean;
  error: string | null;
}

export function useEventDoc(eventId: string | null | undefined): EventState {
  const [state, setState] = useState<EventState>({
    event: null,
    loaded: false,
    error: null,
  });

  useEffect(() => {
    if (!eventId) return;
    setState({ event: null, loaded: false, error: null });
    const unsub = onSnapshot(
      doc(db, "events", eventId),
      (snap) => {
        if (!snap.exists()) {
          setState({ event: null, loaded: true, error: "Event not found." });
          return;
        }
        const data = snap.data() as EventDoc;
        applyBranding(data.branding);
        setState({ event: data, loaded: true, error: null });
      },
      (err) => setState((s) => ({ ...s, loaded: true, error: err.message }))
    );
    return () => unsub();
  }, [eventId]);

  return state;
}
